"use client";
import * as React from 'react';
import { cn } from '@/lib/utils';
import { FreeSlider, type FreeSliderProps } from './freeui-slider';

export function FreeSubBar({ className, ...props }: React.HTMLAttributes<HTMLDivElement>) {
  return <div data-slot="freeui-sub-bar" className={cn('freeui-sub-bar',className)} {...props} />;
}
export function FreeSubBarSlider({ tint, icon, label, className, style, ...props }: FreeSliderProps & { tint?: string; icon?: React.ReactNode }) {
  return <div className="freeui-sub-slider" style={{'--freeui-accent':tint,...style} as React.CSSProperties}>{icon}<span>{label}</span><FreeSlider {...props} label={label} showValue={false} thumb="round" className={className} /></div>;
}
export const FreeSubSlider = FreeSubBarSlider;
export function FreeSubBarLabel({className,...props}:React.HTMLAttributes<HTMLSpanElement>){return <span className={cn('freeui-sub-label',className)} {...props}/>;}
